<template>
  <div class="wrapper">
    <button
      @click="onClickHandler"
      class="button"
      :class="{ buttonActive: isActive }"
    >
      <img alt="" class="image" :src="image" />
    </button>
    <small :class="{ textActive: isActive }" class="text">{{ label }}</small>
  </div>
</template>

<script>
export default {
  name: "PaymentCard",
  props: ["image", "label", "isActive"],
  methods: {
    onClickHandler() {
      this.$emit("onClick");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/style/vars";

.wrapper {
  width: fit-content;
}

.button {
  width: 160px;
  height: 80px;
  border: 1px solid rgba($grey, 0.5);
  border-radius: 6px;
  transition: all 0.2s;
}

.buttonActive {
  border-color: $activeColor;
}

.text {
  text-align: center;
  margin-top: 4px;
}

.textActive {
  color: $activeColor;
  font-weight: 600;
}

.image {
  width: 40px;
}
</style>
